/**
* Blog Roll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Blog Roll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'blog-roll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const wrapper = $( '.blog-roll__animation' );
      const leftThree = $( '.__three-card' )[0];
      const middleThree = $( '.__three-card' )[1];
      const rightThree = $( '.__three-card' )[2];
      const leftTwo = $( '.__two-card' )[0];
      const rightTwo = $( '.__two-card' )[1];

      const tl = gsap.timeline();
      if ( window.innerWidth > 1024 ) {
        ScrollTrigger.create( {
          trigger: wrapper,
          animation: tl,
          start: `top 90%`,
          end: `center center`,
          scrub: 0.2,
        } );

        tl.to( leftThree, {rotate: 5, translateX: '-20px'}, 0 );
        tl.to( leftTwo, {rotate: -7, translateX: '-10px'}, 0 );
        tl.to( middleThree, {rotate: -5}, 0 );
        tl.to( rightThree, {rotate: 5, translateX: '20px'}, 0 );
        tl.to( rightTwo, {rotate: 7, translateX: '10px'}, 0 );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'blog-roll', COMPONENT );
} )( app );
